export default __webpack_public_path__ + "static/orderingTerminalAppsVp1-764febc384fbc1739232b0ff3da73cf5.png";